var DualRowPackageWithThermalPadData = require('./dualRowPackageWithThermalPadData.js');
var lib_core = require("lib-core");

var SoicSopData = function(position, angle, init) {
    DualRowPackageWithThermalPadData.apply(this, arguments);
};

lib_core.inherit(SoicSopData, DualRowPackageWithThermalPadData);
lib_core.JsonParser.registerClass(SoicSopData, "SoicSopData");

module.exports = SoicSopData;